import isEmpty from 'lodash/isEmpty'
import { IBriefStep } from '../types'
import { mapContentfulImageAsset } from '@utils/contentful/contentfulImage'

const parseBriefConfiguration = (
  contentfulBriefConfiguration
): IBriefStep[] => {
  if (isEmpty(contentfulBriefConfiguration.filter((x) => x))) {
    return null
  }

  const briefSteps: IBriefStep[] = contentfulBriefConfiguration?.map(
    (stepConfig) => {
      return {
        label: stepConfig?.fields?.label,
        tooltip: stepConfig?.fields?.tooltip?.fields?.h1,
        variant: stepConfig?.fields?.variant,
        key: stepConfig?.fields.keyForSubmittedValue,
        description: stepConfig?.fields?.description,
        featuredMedia: mapContentfulImageAsset(
          stepConfig?.fields?.featuredMedia
        ),
        options: stepConfig?.fields?.options?.map((option) => ({
          label: option?.fields?.label,
          placeholder: option?.fields?.placeholder,
          description: option?.fields?.description,
          image: mapContentfulImageAsset(option?.fields?.image),
          key: option?.fields?.valueKey,
          value: option?.fields?.value,
          textFieldSize: option?.fields?.textFieldSize,
          link: option?.fields?.link,
          alternativeImage: mapContentfulImageAsset(
            option?.fields?.alternativeImage
          ),
          alternativeModeToggleOption:
            option?.fields?.alternativeModeToggleOption?.toLowerCase(),
          alternativeModeToggleOptionValue:
            option?.fields?.alternativeModeToggleOptionValue?.toLowerCase(),
        })),
      }
    }
  )

  return briefSteps || null
}

export { parseBriefConfiguration }
